
$( document ).ready(function() {


  // ----------------------top banner input jQery----------------------- //

  $(".top-banner--input").keyup(function(){
    $(".city-item").each(function(){
      var substring = $(".top-banner--input").val().toLowerCase();  
      var string = $(this).text().toLowerCase();
      if(string.includes(substring)){
        $(this).css("display","block");  
        $(".country-list__container").show();



      } 
      else{
        $(this).hide();

      }
      $(this).click(function(){
        var nry= $(this).text();
        $(".top-banner--input").val(nry);
        $(".country-list__container").hide();
      });

    }); 

  });

  // ===============================Store Finder btn=========================================  //

  //   $(".check_city_btn").click(function(){  
  //     var finder = $(".top-banner--input").val().toLowerCase();
  //     var match=false;
  // console.log('finder '+finder);
  //   var findernew = $(".city-item"); 
  //     findernew.each(function(){
  // //       console.log('findernew'+$(this).text())
  //       var findernew2=$(this).text().toLowerCase();
  //       if(finder == findernew2){
  //  			match=true
  //   		}
  //     });

  //   if(match){
  //         window.location.href = "/collections";
  //         parent.next().text('');
  //       }
  //     else{

  //     $(".banner-left--inner .form-error").show();
  //     }


  //  });


  //   $('.check_city_btn').click(function(){
  //     var input = $('.top-banner--input');
  //     var parent = $('.top-input-wrapper');
  //     if(input.val()){
  //       var has_city = false;
  //       var input = input.val().toLowerCase();
  //       $('datalist#cities option').each(function(){
  //         var city = $(this).attr('value');
  //         city = city.toLowerCase();
  //         if(city == input){
  //           has_city = true;	
  //         }
  //       });
  //       if(has_city){
  //         window.location.href = "/collections";
  //         parent.next().text('');
  //       }else{
  //         parent.next().text(parent.attr('data-no-found'));      
  //       }
  //     }else{
  //       parent.next().text(parent.attr('data-empty'));
  //     }
  //   });

  $('.dropdown-select1 li').click(function(){
    var country = $(this).text();
   var iso_code =  $('#localization_form select option[data-country="'+country+'"]').attr('value');
    if(iso_code == 'GB'){
      $('.popup-button').find('.country span').text('UK');
    }else{
      $('.popup-button').find('.country span').text(iso_code);
    }
    
    $('#localization_form select').val(iso_code).change();
  });
  $(".check_city_btn").click(function(){  
    var country =  $(".dropdown-button").text();
    var country2 =  $(".top-banner--input").text();

    var country_placeholder =  $(".dropdown-button").attr('data-label');
    var country2_placeholder =  $(".top-banner--input").attr('data-label');


    var parent = $('.ttop-input-wrapper');
    parent.next().text('');
    var err = "";

    if(country.indexOf(country_placeholder) < 0 && country2.indexOf(country2_placeholder) < 0)
    {
    // if(country2 == 'Canada'){
    //         window.location.href = "https://ca.cherrypick.city/collections";
    // }else if(country2 == 'Netherlands'){
    //         window.location.href = "https://nl.cherrypick.city/collections";
    // }else{
    //   window.location.href = "https://cherrypick.city/collections";     
    // }
      console.log('if working');
      $('#localization_form input[type="submit"]').click();
      parent.next().text('');
    } else {
      console.log('else working');
      if(country.indexOf(country_placeholder) > -1){
        err = $(".dropdown-button").attr('data-error');
      } else {
        err = $(".top-banner--input").attr('data-error');
      }
      $(".banner-left--inner .form-error").text(err).show();
    }
  });


  $(".dropdown-button").click(function() {
    $(this).addClass('scbtn');
    var docClick = function(ev){
      if(!$(ev.target).hasClass('dropdown-button')) {
        closeDropdown();
      }
    }

    var closeDropdown = function() {
      $(".dropdown-menu").removeClass("show-menu");
      $('.dropdown-button').removeClass('scbtn');
      $(document).unbind('click', docClick);
    }

    if($(".dropdown-menu").hasClass("show-menu")) {
      closeDropdown();
    }else{
      $(document).bind('click', docClick )
      $(".dropdown-menu").addClass("show-menu");
    }

    $(".dropdown-menu > li").click(function(){
      closeDropdown();
    });
    $(".dropdown-menu.dropdown-select > li").click(function() {
      $(".dropdown-button").html($(this).html());
    });
  });

  //   2nd dropdown
$(".top-banner--input").each(function(){
    $(this).click(function() {
    // console.log('ghhhhh')
    $(this).addClass('scbtn1');
    var docClick1 = function(ev){
      if(!$(ev.target).hasClass('top-banner--input')) {
        closeDropdown1();
      }
    }

    var closeDropdown1 = function() {
      $(".dropdown-menu1").removeClass("show-menu1");
      $('.top-banner--input').removeClass('scbtn1');
      $(document).unbind('click', docClick1);
    }

    if($(".dropdown-menu1").hasClass("show-menu1")) {
      closeDropdown1();
    }else{
      $(document).bind('click', docClick1 )
      // $(".dropdown-menu1").addClass("show-menu1");
      $(this).siblings('.country-list__container').find(".dropdown-menu1").addClass("show-menu1");
    }

    $(".dropdown-menu1 > li").click(function(){
      closeDropdown1();
    });
    $(".dropdown-menu1.dropdown-select1 > li").click(function() {
      $(".top-banner--input").html($(this).html());
    });
  });
});
  // $(".top-banner--input").click(function() {
  //   console.log('ghhhhh')
  //   $(this).addClass('scbtn1');
  //   var docClick1 = function(ev){
  //     if(!$(ev.target).hasClass('top-banner--input')) {
  //       closeDropdown1();
  //     }
  //   }

  //   var closeDropdown1 = function() {
  //     $(".dropdown-menu1").removeClass("show-menu1");
  //     $('.top-banner--input').removeClass('scbtn1');
  //     $(document).unbind('click', docClick1);
  //   }

  //   if($(".dropdown-menu1").hasClass("show-menu1")) {
  //     closeDropdown1();
  //   }else{
  //     $(document).bind('click', docClick1 )
  //     $(".dropdown-menu1").addClass("show-menu1");
  //   }

  //   $(".dropdown-menu1 > li").click(function(){
  //     closeDropdown1();
  //   });
  //   $(".dropdown-menu1.dropdown-select1 > li").click(function() {
  //     $(".top-banner--input").html($(this).html());
  //   });
  // });


  // ------------------------------------------- //
//   $(document).mouseup(function(event) 
//                       {
//     var div = $(".top-banner--input");
//     if (!div.is(event.target) && div.has(event.target).length === 0) 
//     {
//       $(".country-list__container").hide();
//     }
//   });
  //   ===================================================================  //


  $('.store_slider_wrapper').slick({
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows:2

        }
      }
    ]
  });
  //   ----------------------------------------------------------------- //
  //   ----------------------------------------------------------------- //
  var slider = $('.featured-slider--container');

  if($(window).width() <=767 ){
    $('#choose-slider--main').removeClass('featured-slider--container');  
    var slidermobile = $('.featured-slider--container_mobile');
    slidermobile.slick({
      autoplay: slidermobile.attr('data-autoplay'),
      autoplaySpeed: slidermobile.attr('data-autoplaySpeed'),
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      dots: true,
      arrows: true
    });
  }
  else{  
    slider.slick({
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true
          }

        }
      ]
    });
  }
  if ((!$('#choose-slider--main').hasClass("featured-slider--container")) && (!$('#choose-slider--main').hasClass("featured-slider--container_mobile"))  ) {
    $('#choose-slider--main .single_feature_item:nth-of-type(odd)').css({"background-color": "rgb(242, 92, 84)", "border-radius": "20px"});
    $('#choose-slider--main .single_feature_item:nth-of-type(even)').css({"background-color": "#9d0e3c", "border-radius": "20px"});
    $('#choose-slider--main .single_feature_item').css("margin-bottom", "20px");

  }
  //   ----------------------------------------------------------------  //
  //   ----------------------------------------------------------------  //
  var slider2 = $('.home-work--slider');
  if($(window).width() <=767 ){
    slider2.slick({
      autoplay: slider2.attr('data-autoplay'),
      autoplaySpeed: slider2.attr('data-autoplaySpeed'),
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      dots: true,
      arrows: true
    });
  }

  //   ---------------------------------------------------------- //
  //   ---------------------------------------------------------- //
  $('.testimonials-content_area').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    //     prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    //     nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1

        }
      },
      {
        breakpoint: 481,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // ---------------------------------------------------------------- //
  // ---------------------------------------------------------------- //
  var slider3 = $('.shoppers-slider');
  if($(window).width() <=767 ){
    slider3.slick({
      autoplay: slider3.attr('data-autoplay'),
      autoplaySpeed: slider3.attr('data-autoplaySpeed'),
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      dots: true,
      arrows: true
    });
  }
  //   ------------------------------------------------------------------  //
  //   ------------------------------------------------------------------  //
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
      if ($(".accordion").hasClass("active")) {
        $(this).parent().addClass("faq-border");

      } 
      else{
        $(this).parent().removeClass("faq-border");
        $(this).parent().siblings().removeClass("faq-border");
      }
    });
  }
  // -------------------------------------------------------------- //
  $(".annoucement_close").click(function(){
    $(".annoucement_bar").hide();

  });

  $('.slider-btn--container .next-slide').click(function(){
    $(this).parents('.section').find('.slick-js-slider .slick-next').click();
  });

  $('.slider-btn--container .back-slide').click(function(){
    $(this).parents('.section').find('.slick-js-slider .slick-prev').click();
  });

  //   -------------------------------------------------------------------- //
  $(".nav-collapse--btn").click(function(){
    $(".side-bg-overlay").show();
    $(".drawer-right--container").addClass("collapse-click");
    $("body").css('overflow','hidden');
  });
  $('.menu-drawer-content ul li a').on('click', function(){
    $(".close-sidebar").trigger('click');
  });
  $(".close-sidebar").click(function(){
    $(".side-bg-overlay").hide();
    $(".drawer-right--container").removeClass("collapse-click");
    $("body").css('overflow','auto');
  });
  // -----------------announcement bar js----------------- //
  $(".discount_box").click(function(){
    var dicount_code = $(this).text();
    $(".annoucement_bar").css("background","rgb(242, 92, 84)");
    $(".announcement_text").html("Code Copied! Please Apply at Checkout. <span class='copy_to_clipboard discount_box'>"+dicount_code+"</span><div class='annoucement_close'>X</div>");
    $(".announcement_text").find("span").css("cursor","unset");
    $(".announcement_text").css("font-weight","bold");
    $(".announcement_text").find("div").click(function(){
      $(".annoucement_bar").hide();

    });
  });


  // --------------------------------- //
  if ($("#work-slide--main").hasClass("home-work--slider")) {
    $(".single_feature_item").removeClass("work-block--new");
  }
  else{
    $(".single_feature_item").addClass("work-block--new");
  }


  $('.testimonial_content_wrapper').matchHeight();
  //   $('.item_content_wrapper').matchHeight();


  var url = window.location.href;
  console.log(url);
  if(url.includes('customer_posted=true')){
    setTimeout(function(){
    $('html, body').animate({scrollTop: $("#contact_form").offset().top - 100}, "fast");  
      }, 1000); 
  }
  if(url.includes('form_type=customer#contact_form')){
    setTimeout(function(){
    $('html, body').animate({scrollTop: $("#contact_form").offset().top - 100}, "fast");  
      }, 1000); 
  }
  
});


function SelfCopy(copyText)
{
  navigator.clipboard.writeText(copyText);
}

// });





